module.exports = __webpack_public_path__ + "img/TV.b6f892da.svg";